import React from 'react';

import {
  IonBadge,
  IonIcon,
  IonItem,
  IonItemOptions,
  IonItemSliding,
  IonLabel,
} from '@ionic/react';
import { checkmark } from 'ionicons/icons';

import { ListItemConfig } from './interfaces';

const defaultGetLabel = (option: any) => option?.name;
const defaultIsSelected = (): any => false;
const defaultGetBadge = (): any => false;

const ListItem: React.FC<ListItemConfig> = ({
  option,
  getLabel = defaultGetLabel,
  getBadge = defaultGetBadge,
  isSelected = defaultIsSelected,
  onItemClick,
  secondaryActions,
  primaryActions,
}) => {
  const optLabel = getLabel(option);
  const selected = isSelected(option);
  const badgeLabel = getBadge(option);
  const meta = { selected };

  const primaryActionComponent = primaryActions && primaryActions(option, meta);

  const secondaryActionsComponent =
    secondaryActions && secondaryActions(option, meta);

  return (
    <IonItemSliding
      key={`${optLabel}_${selected}_${primaryActionComponent}_${secondaryActionsComponent}`}
    >
      {primaryActionComponent && (
        <IonItemOptions side={'start'}>{primaryActionComponent}</IonItemOptions>
      )}
      <IonItem
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          if (onItemClick) {
            onItemClick(e, option);
          }
        }}
        button={true}
        detail={false}
        style={{ minHeight: '1px' }}
      >
        <IonIcon
          color={'primary'}
          icon={selected ? checkmark : undefined}
          slot={'start'}
        />

        <IonLabel>{optLabel}</IonLabel>

        {badgeLabel ? (
          <IonBadge color={badgeLabel.color} slot={'end'} className={'badge'}>
            {badgeLabel.label}
          </IonBadge>
        ) : null}
      </IonItem>
      {secondaryActions && (
        <IonItemOptions side={'end'}>
          {secondaryActions(option, meta)}
        </IonItemOptions>
      )}
    </IonItemSliding>
  );
};

export default ListItem;
